import "./modules/core-js";
import { onReady } from "./modules/window-service";

onReady(() => { 
    const form = document.getElementById('wf-form-roi-calculator') as HTMLFormElement;
    if(!form) return;
    form.onsubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const val = (name) => parseInt((form.elements.namedItem(name) as HTMLInputElement)?.value);

        const workHoursPerYear = 2080;
        const timeSavingsExpenses = 0.7116;
        const timeSavingsBooks = 0.2511;
        const rewardRate = 0.0052;
        
        const hourlyRateEmp = val('emp-salary') / workHoursPerYear;
        const minutesPerReport = val('time-per-report');
        const monthlyTimeSavingsEmp = val('num-emp-reporting') * val('reports-per-employee') * (minutesPerReport / 60) * timeSavingsExpenses;
        const monthlyMoneySavingsEmp = monthlyTimeSavingsEmp * hourlyRateEmp;


        const hourlyRateFin = val('fin-salary') / workHoursPerYear;
        const hoursToCloseBooks = val('fin-days-taken') * 8;
        const monthlyTimeSavingsFin = hoursToCloseBooks * timeSavingsBooks + val('fin-hours-spend') * timeSavingsExpenses;
        const monthlyMoneySavingsFin = monthlyTimeSavingsFin * hourlyRateFin;

        const monthlyReward = val('credit-spend') * rewardRate;
        const totalAnnualMoneySaving = (monthlyMoneySavingsEmp + monthlyMoneySavingsFin + val('software-cost') + monthlyReward) * 12;
        const totalAnnualTimeSavings = (monthlyTimeSavingsFin + monthlyTimeSavingsEmp) * 12;


        const timeSavedHtml = document.getElementById('time-saved');
        const moneySavedHtml = document.getElementById('money-saved');
        if(!timeSavedHtml || !moneySavedHtml) return;
        timeSavedHtml.innerText = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(totalAnnualTimeSavings || 0) + ' hrs';
        moneySavedHtml.innerText = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(totalAnnualMoneySaving || 0);
        
        // scroll into view
        const element = document.getElementById('time-saved');
        if(!element) return;
        const y = element.getBoundingClientRect().top + window.scrollY - 250;
        window.scrollTo({top: y, behavior: 'smooth'});
    }; 
});
